module.exports = __webpack_public_path__ + "img/pinterest.fb869a59.svg";